import React, { useEffect, useState, useCallback, useRef } from 'react'
import Header from '../sharedFiles/header/header'
import Footer from '../sharedFiles/footer/footer'
import './customerCreation.css';
import ProgressBar from '../sharedFiles/prograssBar/PrograssBar';
import { useDispatch, useSelector } from 'react-redux';
import { CustomerCreationAction, resetCustomerDetails, UpdateCustomerDataAction } from '../ReduxStore/actions';
import { TextField, Typography } from '@mui/material';
import _ from 'lodash';
import { selectUser } from '../ReduxStore/userReducer';
import { useNavigate } from 'react-router-dom';
import { GetData } from '../API/getApi';
import { AccountData, PostCustomerData } from '../API/API';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { PostData } from '../API/postApi';
import { useOutsideAlerter } from '../sharedFiles/dropdownCloser/dropdownCloser';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const CustomerCreation = () => {
    const dispatch = useDispatch();
    const userData = useSelector(selectUser);
    const navigate = useNavigate();
    const customerData = useSelector((state) => state.item.customerData);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (customerData) {
            dispatch(CustomerCreationAction(customerData));
        }
    }, [customerData, dispatch]);

    // Ensure customerData is defined before destructuring
    const CustomerDetails = customerData ? customerData.CustomerDetails : {};

    const handleSubmit = async () => {
        setLoading(true);
        const jwtToken = userData?.JwtToken;
        try {
            const response = await PostData(PostCustomerData + userData.DatabaseName, CustomerDetails, jwtToken, dispatch, navigate);
            const result = response.result;
            if (result === 'OK'){
                setLoading(false);
                handleReset();
            } else {
                setLoading(false);
            }
            // Handle the response as needed
        } catch (error) {
            console.error('Error in handleSubmit:', error);
            toast(error.message, {
                position: "bottom-right",
                theme: "dark",
            });
            setLoading(false); // Ensure loading is reset in case of an error
        }
    };
    const handleReset = () => {
        dispatch(resetCustomerDetails());
    }
    const handleBackNav = () => {
        navigate("/DashBoard")
    }
  return (
    <>
    <Header/>
       <div className='customerCreation'>
            <div className='dashImage'></div>
            <div className='dashGradient'></div>
            <div className='bpMain'>
                <div className='topCustomerCreation'>
                    <button onClick={handleBackNav} className="backIcondiv">
                        <ArrowCircleLeftIcon />
                        <p className="DashBoardName col-xl-7 col-xxl-11 col-10 col-md-11">
                            Dashboard
                        </p>
                    </button>
                </div>
                <ProgressBar 
                    handleSubmit={handleSubmit} 
                    // handleReset={handleReset()}
                    />
            </div>         
       </div>
    <Footer/>
    </>
  )
}

export default CustomerCreation;

export const BasicCustomerDetails = ({ onValidationChange }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const customerData = useSelector((state) => state.item.customerData);
    const { CustomerDetails } = customerData;
    const [CustomerDet, setCustomerDetails] = useState({
        customerName:'' ,
        ForeignName: '',
        GroupName:'',
        GroupCode:'',
        salesPerson:'',
        SlpCode:'',
        mobileNumber:'',
        phone:'',
        Email:'',
        Address_Block:'',
        Address_Street: '',
        Address_City:'',
        Address_State:'',
        stateName:'',
        Address_Id: 'Default',
        Address_Country: 'India',
        Address_ZipCode: '',
    });
    const [errors, setErrors] = useState({});
    const [ForeignName, setForeignName]= useState('');
    const [customerName, setCustomerName]= useState('');
    const [groupName, setGroupName]= useState('');
    const [salesPerson, setSalesPerson]= useState('');
    // const [phone, setphone]= useState('');
    const [Email, setEmail]= useState('');
    const [Block, setBlock]= useState('');
    const [Street, setStreet]= useState('');
    const [City, setCity]= useState('');
    // const [State, setState]= useState('');
    const [Country, setCountry]= useState("India");
    // const [PinCode, setPinCode]= useState('');
    // const [mobileNumber, setMobileNumber]= useState('');
    const [GroupListName, setGroupListName] = useState('');
    const [stateList, setStateList] = useState('');
    const [salesPersonList, setSalesPersonList] = useState('');
    const userData = useSelector(selectUser);
    const userId = userData?.UserId;
    const jwtToken = userData?.JwtToken;
    const databaseName = userData?.DatabaseName;
    const [groupShow, SetGroupShow] = useState(false);
    const [SalesShow, SetSalesShow] = useState(false);
    const [StateShow, SetStateShow] = useState(false);
    const prevCustomerDetRef = useRef();
    // const [groupSearchTerm, setGroupSearchTerm] = useState('');
    // const [filteredGroups, setFilteredGroups] = useState(GroupListName);
    
/********** This is for get the group list and sales person list *********/
        useEffect(() => {
        const fetchAccountData = async () => {
            try {
                const accountData = await GetData(`${AccountData}${userId}&dbName=${databaseName}`, {
                    headers: {
                        wg_token: jwtToken,
                    },
                }, dispatch, navigate);
                const state = accountData.item1
                const salesPerson = accountData.item2;
                const group = accountData.item3;
                setStateList(state);
                setSalesPersonList(salesPerson);
                setGroupListName(group)
            } catch (error) {
                console.error("Error fetching group list:", error);
            }
        };
        fetchAccountData();
    }, [databaseName, jwtToken, dispatch]);

/******** This will helps to update a values in customerdetails without any re-render errors **********/
   
    const debouncedUpdate = useCallback(
        _.debounce((updatedDetails) => {
            dispatch(UpdateCustomerDataAction({ CustomerDetails: updatedDetails }));
        }),
        [dispatch]
    );

/******** This will handle a input changes in all input fields *********/
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'customerName') {
            setCustomerName(value);
        }
        if (name === 'ForeignName') {
            setForeignName(value);
        }
        // if (name === 'mobileNumber') {
        //     setMobileNumber(value);
        // }
        // if (name === 'phone') {
        //     setphone(value);
        // } 
        if (name === 'Email') {
            setEmail(value);
        }
        if (name === 'Address_Block') {
            setBlock(value);
        } 
        if (name === 'Address_Street') {
            setStreet(value);
        } 
        if (name === 'Address_City') {
            setCity(value);
        } 
        // if (name === 'Address_State') {
        //     setState(value);
        // } 
        if (name === 'Address_Country') {
            setCountry(value);
        } 
        if (name === 'Address_ZipCode') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Only numbers are allowed'
                }));
                return;
            } else if (value.length > 6) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Maximum 10 digits allowed'
                }));
                return;
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: ''
                }));
            }
        }
        if (name === 'mobileNumber' || name === 'phone') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Only numbers are allowed'
                }));
                return;
            } else if (value.length > 10) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Maximum 10 digits allowed'
                }));
                return;
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: ''
                }));
            }
        }
        /****** This will helps to store a value in customerdetails ********/
        const updatedDetails = {
            ...CustomerDet,
            [name]: value
        };

        setCustomerDetails(updatedDetails);

        /******* This will set a errors *********/
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: value ? '' : `${name} is required`
        }));

        setForeignName('');
        setCustomerName('');
        setGroupName('');
        setSalesPerson('');
    };
    const handleInputBlur = (e) => {
        const { name, value } = e.target;
    
        // Validate email format on blur
        if (name === 'Email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Invalid email format'
                }));
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: ''
                }));
            }
        }
    };

    const deepEqual = (obj1, obj2) => {
        if (obj1 === obj2) return true;
    
        if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
            return false;
        }
    
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
    
        if (keys1.length !== keys2.length) return false;
    
        for (let key of keys1) {
            if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) return false;
        }
    
        return true;
    };

/******* This will helps to update a values when above debounce will triggers *********/
useEffect(() => {
    const prevCustomerDet = prevCustomerDetRef.current;

    if (prevCustomerDet && !deepEqual(CustomerDet, prevCustomerDet)) {
        debouncedUpdate(CustomerDet);
    }

    prevCustomerDetRef.current = CustomerDet;
}, [CustomerDet, debouncedUpdate]);

/******** This is for checking a old values in the customerdetails *******/
    useEffect(() => {
        if (CustomerDetails && (
            CustomerDetails.customerName !== CustomerDet.customerName || 
            CustomerDetails.ForeignName !== CustomerDet.ForeignName ||
            CustomerDetails.GroupName !== CustomerDet.GroupName ||
            CustomerDetails.salesPerson !== CustomerDet.salesPerson ||
            CustomerDetails.mobileNumber !== CustomerDet.mobileNumber ||
            CustomerDetails.phone !== CustomerDet.phone ||
            CustomerDetails.Email !== CustomerDet.Email ||
            CustomerDetails.Address_Block !== CustomerDet.Address_Block ||
            CustomerDetails.Address_Street !== CustomerDet.Address_Street ||
            CustomerDetails.Address_City !== CustomerDet.Address_City ||
            CustomerDetails.Address_State !== CustomerDet.Address_State ||
            CustomerDetails.Address_ZipCode !== CustomerDet.Address_ZipCode
        )) {
            setCustomerDetails({
                customerName: CustomerDetails.customerName || '',
                ForeignName: CustomerDetails.ForeignName || '',
                GroupName: CustomerDetails.GroupName || '',
                salesPerson: CustomerDetails.salesPerson || '',
                mobileNumber: CustomerDetails.mobileNumber || '',
                phone: CustomerDetails.phone || '',
                Email: CustomerDetails.Email || '',
                Address_Block: CustomerDetails.Address_Block || '',
                Address_Street: CustomerDetails.Address_Street || '',
                Address_Id: CustomerDetails.Address_Id || 'Default',              
                Address_City: CustomerDetails.Address_City || '',
                stateName: CustomerDetails.stateName || '',
                Address_Country: CustomerDetails.Address_Country || 'India',
                Address_ZipCode: CustomerDetails.Address_ZipCode || '',
            });
        }
    }, [CustomerDetails]);
/******** This will helps to disable the next button without getting all values*********/
    useEffect(() => {
        const isValid = CustomerDet.customerName && 
                        CustomerDet.GroupName && 
                        CustomerDet.salesPerson && 
                        CustomerDet.mobileNumber && 
                        CustomerDet.Email && 
                        CustomerDet.Address_Block && 
                        CustomerDet.Address_Street && 
                        CustomerDet.Address_City && 
                        CustomerDetails.Address_State && 
                        CustomerDet.Address_ZipCode;
        onValidationChange(isValid);
    }, [CustomerDet, onValidationChange]);

/******** This will helps to update a groupname to customerdetails when click the groupname list in dropdown *******/
    const handleGroupSelect = (groupName, groupCode) => {
        setGroupName(groupName);
        setCustomerDetails((prevState) => ({
            ...prevState,
            GroupName: groupName,
            GroupCode:groupCode
        }));
        setErrors(false);
        SetGroupShow(false); // Hide the group list after selection
    };
/******** This will helps to update a sales person name to customerdetails when click the sales Person list in dropdown *******/
    const handleSalesSelect = (salesName, SlpCode) => {
        setSalesPerson(salesName);
        setCustomerDetails((prevState) => ({
            ...prevState,
            salesPerson: salesName,
            SlpCode: SlpCode
        }));
        setErrors(false);
        SetSalesShow(false); // Hide the group list after selection
    };

    const handleStateSelect = (name, code) => {
        setCustomerDetails((prevState) => ({
            ...prevState,
            stateName: name,
            Address_State : code
        }));
        setErrors(false);
        SetStateShow(false);
    }
/******** This will trigger to show the group list and sales person list *********/
    const toggleGroupShow = () => {
        SetGroupShow(!groupShow);
    };
    const toggleStateShow = () => {
        SetStateShow(!StateShow);
    };
    const toggleSalesShow = () => {
        SetSalesShow(!SalesShow);
    }
    //   const handleGroupSearchInputChange = (e) => {
    //     const searchTerm = e.target.value;
    //     setGroupSearchTerm(searchTerm);
    //     if (searchTerm === "") {
    //         setFilteredGroups(GroupListName); // Reset to original list if search term is empty
    //     } else {
    //         const filteredData = GroupListName.filter(
    //             (group) =>
    //                 group.groupName.toLowerCase().includes(searchTerm.toLowerCase())
    //         );
    //         setFilteredGroups(filteredData);
    //     }

    // };
    const wrapperRef = React.useRef(null);
  useOutsideAlerter(wrapperRef, () => SetStateShow(false));
  useOutsideAlerter(wrapperRef, () => SetGroupShow(false));
  useOutsideAlerter(wrapperRef, () => SetSalesShow(false));
    return (
        <div>
            <div className='StepperGradient'>
            </div>
            <div className='FormDiv'>
            <div className='customerstepper'>
                <div className='errorTextField '>
                <TextField 
                    id="customerName"
                    name="customerName"
                    label="Customer Name"
                    variant="outlined"
                    className='SecondRowStepper'
                    required
                    autoComplete='off'
                    value={CustomerDet.customerName}
                    onChange={handleInputChange}
                />
                {errors.customerName && (
                    <Typography color="error" variant="caption">{errors.customerName}</Typography>
                )}
                </div>
            </div>
            <div className='RowStepper  rightRowStepper'>
            <div className='errorTextField rightTextField'>
                <TextField 
                    id="ForeignName"
                    name="ForeignName"
                    label="Foreign Name"
                    variant="outlined"
                    autoComplete='off'
                    className='noErrorRowStepper'
                    value={CustomerDet.ForeignName}
                    onChange={handleInputChange}
                />
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="GroupName" 
                    label="Group Name"
                    name="GroupName" 
                    variant="outlined" 
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.GroupName}
                    onChange={handleInputChange}
                    // onChange={handleGroupSearchInputChange}
                    onClick={toggleGroupShow}
                />
                {errors.GroupName && (
                    <Typography color="error" variant="caption">{errors.GroupName}</Typography>
                )}
                {groupShow && GroupListName && (
                    <ul className="GroupContainer GroupPosition" ref={wrapperRef}>
                        {GroupListName.map((Group, index) => (
                            <li
                                key={index}
                                onClick={() => handleGroupSelect(Group.groupName, Group.groupCode)}
                            >
                                {Group.groupName}
                            </li>
                        ))}
                    </ul>
                )}
                </div>
                <div className='errorTextField rightTextField'>
                <TextField
                    id="salesPerson"   
                    label="Sales Person" 
                    variant="outlined"
                    name="salesPerson"
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.salesPerson}
                    onChange={handleInputChange}
                    onClick={toggleSalesShow}
                />
                {errors.salesPerson && (
                    <Typography color="error" variant="caption">{errors.salesPerson}</Typography>
                )}
                  {SalesShow && salesPersonList && (
                    <ul className="GroupContainer SalesPosition" ref={wrapperRef}>
                        {salesPersonList.map((Sales, index) => (
                            <li
                                key={index}
                                onClick={() => handleSalesSelect(Sales.slpName, Sales.slpCode)}
                            >
                                {Sales.slpName}
                            </li>
                        ))}
                    </ul>
                )}
                </div>
            </div>
            <div className='RowStepper  rightRowStepper2'>
            <div className='errorTextField rightTextField'>
                <TextField 
                    id="mobileNumber" 
                    label="Mobile Number" 
                    variant="outlined" 
                    name="mobileNumber"
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.mobileNumber}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                    inputProps={{ maxLength: 10 }}
                />
                {errors.mobileNumber && (
                    <Typography color="error" variant="caption">{errors.mobileNumber}</Typography>
                )}
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="phone" 
                    label="Phone" 
                    variant="outlined" 
                    name="phone"
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.phone}
                    onBlur={handleInputBlur}
                    onChange={handleInputChange}
                />
                {errors.phone && (
                    <Typography color="error" variant="caption">{errors.phone}</Typography>
                )}
                </div>
                {/* <div className='errorTextField'>
                <TextField 
                    id="Email" 
                    label="Email" 
                    variant="outlined" 
                    required
                    name="Email"
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.Email}
                    onChange={handleInputChange}
                />
                {errors.Email && (
                    <Typography color="error" variant="caption">{errors.Email}</Typography>
                )}
                </div> */}
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="Email" 
                    label="Email" 
                    variant="outlined" 
                    required
                    name="Email"
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.Email}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur}
                />
                {errors.Email && (
                    <Typography color="error" variant="caption">{errors.Email}</Typography>
                )}
            </div>
            </div>
            <div className='RowStepper leftRowStepper'>
                <div className='errorTextField rightTextField'>    
                <TextField 
                    id="Block" 
                    label="Block" 
                    variant="outlined" 
                    name="Address_Block"
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.Address_Block}
                    onChange={handleInputChange}
                />
                {errors.Block && (
                    <Typography color="error" variant="caption">{errors.Block}</Typography>
                )}
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="Street" 
                    label="Street" 
                    variant="outlined" 
                    name="Address_Street"
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.Address_Street}
                    onChange={handleInputChange}
                />
                {errors.Street && (
                    <Typography color="error" variant="caption">{errors.Street}</Typography>
                )}
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="City" 
                    label="City" 
                    variant="outlined" 
                    name="Address_City"
                    required
                    autoComplete='off'
                    className='SecondRowStepper'
                    value={CustomerDet.Address_City}
                    onChange={handleInputChange}
                />
                {errors.City && (
                    <Typography color="error" variant="caption">{errors.City}</Typography>
                )}
                </div>
            </div>
            <div className='RowStepper leftRowStepper2'>
            <div className='errorTextField rightTextField'>
                <TextField 
                    id="State" 
                    label="State" 
                    variant="outlined" 
                    name="Address_State"
                    autoComplete='off'
                    required
                    className='SecondRowStepper'
                    value={CustomerDet.stateName}
                    // onChange={handleInputChange}
                    onClick={toggleStateShow}
                />
                {errors.State && (
                    <Typography color="error" variant="caption">{errors.State}</Typography>
                )}
                {StateShow && stateList && (
                    <ul className="StateContainer"  ref={wrapperRef}>
                        {stateList.map((state, index) => (
                            <li
                                key={index}
                                onClick={() => handleStateSelect(state.name, state.code)}
                            >
                                {state.name}
                            </li>
                        ))}
                    </ul>
                )}
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="Country" 
                    label="Country" 
                    variant="outlined" 
                    autoComplete='off'
                    name="Address_Country"
                    className='noErrorRowStepper'
                    value={CustomerDet.Address_Country}
                    // onChange={handleInputChange}
                    // InputProps={{
                    //     readOnly: true,
                    // }}
                />
                </div>
                <div className='errorTextField rightTextField'>
                <TextField 
                    id="PinCode" 
                    label="Pin Code" 
                    variant="outlined" 
                    name="Address_ZipCode"
                    required
                    className='SecondRowStepper'
                    autoComplete='off'
                    value={CustomerDet.Address_ZipCode}
                    onChange={handleInputChange}
                />
                {errors.Address_ZipCode && (
                    <Typography color="error" variant="caption">{errors.Address_ZipCode}</Typography>
                )}
                </div>
            </div>
            </div>
        </div>
    )
}

export const ContactPersonDetails = ({ onValidationChange }) => {
    const dispatch = useDispatch();
    const customerData = useSelector((state) => state.item.customerData);
    const { CustomerDetails } = customerData;
    const [errors, setErrors] = useState({});

    const [CustomerDet, setCustomerDetails] = useState({
        ContactEmployeeName: '',
        ContactEmployeePosition: '',
        ContactEmployeePhone: '',
        ContactEmployeeMobileNumber: '',
        ContactEmployeeEmail: '',
        ContactEmployeeAddress: '',
    });

/******** This is for checking a old values in the customerdetails *******/
    useEffect(() => {
        if (CustomerDetails) {
            setCustomerDetails({
                ContactEmployeeName: CustomerDetails.ContactEmployeeName || '',
                ContactEmployeePosition: CustomerDetails.ContactEmployeePosition || '',
                ContactEmployeePhone: CustomerDetails.ContactEmployeePhone || '',
                ContactEmployeeMobileNumber: CustomerDetails.ContactEmployeeMobileNumber || '',
                ContactEmployeeEmail: CustomerDetails.ContactEmployeeEmail || '',
                ContactEmployeeAddress: CustomerDetails.ContactEmployeeAddress || '',
            });
        }
    }, [CustomerDetails]);

/******** This will handle a input changes in all input fields *********/
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'ContactEmployeeMobileNumber') {
            const regex = /^[0-9]*$/;
            if (!regex.test(value)) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Only numbers are allowed'
                }));
                return;
            } else if (value.length > 10) {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: 'Maximum 10 digits allowed'
                }));
                return;
            } else {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    [name]: ''
                }));
            }
        }
        setCustomerDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value
        }));
          /******* This will set a errors *********/
          setErrors(prevErrors => ({
            ...prevErrors,
            [name]: value ? '' : `${name} is required`
        }));
    };

// Use debounce to prevent too many updates to the Redux store
    const debouncedUpdate = useCallback(
        _.debounce((updatedDetails) => {
            dispatch(UpdateCustomerDataAction({ CustomerDetails: updatedDetails }));
        }, 300),
        [dispatch]
    );

/******** This will update a values in CustomerDet *******/
    useEffect(() => {
        debouncedUpdate(CustomerDet);
    }, [CustomerDet, debouncedUpdate]);

/******** This will helps to disable the next button without getting all values*********/
    useEffect(() => {
        const isValid = CustomerDet.ContactEmployeeName && 
                        CustomerDet.ContactEmployeeMobileNumber 
        onValidationChange(isValid);
    }, [CustomerDet, onValidationChange]);
    return (
        <div>
            <div className='StepperGradient'></div>
            <div className='FormDiv'>
            <div className='RowStepper rowstepper2 flex-column align-items-center'>
            <div className='errorTextField'>
                <TextField 
                    id="ContactPersonDetail"
                    name="ContactEmployeeName"
                    label="Contact Person Detail"
                    variant="outlined"
                    required
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeeName}
                    onChange={handleInputChange}
                />
                {errors.ContactEmployeeName && (
                    <Typography color="error" variant="caption">{errors.ContactEmployeeName}</Typography>
                )}
                </div>
                <div className='errorTextField'>
                <TextField 
                    id="Designation"
                    name="ContactEmployeePosition"
                    label="Designation"
                    variant="outlined"
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeePosition}
                    onChange={handleInputChange}
                />
                </div>
                <div className='errorTextField'>
                <TextField 
                    id="Phone" 
                    label="Phone"
                    name="ContactEmployeePhone" 
                    variant="outlined" 
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeePhone}
                    onChange={handleInputChange}
                />
                </div>
                <div className='errorTextField'>
                <TextField
                    id="Mobile"   
                    label="Mobile" 
                    variant="outlined"
                    name="ContactEmployeeMobileNumber"
                    required
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeeMobileNumber}
                    onChange={handleInputChange}
                />
                {errors.ContactEmployeeMobileNumber && (
                    <Typography color="error" variant="caption">{errors.ContactEmployeeMobileNumber}</Typography>
                )}
                </div>
                <div className='errorTextField'>
                <TextField 
                    id="Email" 
                    label="E-Mail" 
                    variant="outlined" 
                    name="ContactEmployeeEmail"
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeeEmail}
                    onChange={handleInputChange}
                />
                </div>
                <div className='errorTextField'>
                <TextField 
                    id="Address" 
                    label="Address" 
                    variant="outlined" 
                    name="ContactEmployeeAddress"
                    className='SecondRowStepper'
                    value={CustomerDet.ContactEmployeeAddress}
                    onChange={handleInputChange}
                />
                </div>
            </div>
            </div>
        </div>
    )
}

export const TaxDetails = ({onValidationChange}) => {
    const dispatch = useDispatch();
    const customerData = useSelector((state) => state.item.customerData);
    const { CustomerDetails } = customerData;
    const [CustomerDet, setCustomerDetails] = useState({
        Address_GstNumber:'' ,
        Tax_PanNo: '',
    });
    const [GSTNumber, setGSTNumber] = useState('');
    const [PanCardNumber, setPanCardNumber] = useState('');
    const [errors, setErrors] = useState({});

 // This is for checking a old values in the customerdetails 
    useEffect(() => {
        if (CustomerDetails && (
            CustomerDetails.Address_GstNumber !== CustomerDet.Address_GstNumber || 
            CustomerDetails.Tax_PanNo !== CustomerDet.Tax_PanNo 
        )) {
            setCustomerDetails({
                Address_GstNumber: CustomerDetails.Address_GstNumber || '',
                Tax_PanNo: CustomerDetails.Tax_PanNo || '',
            });
        }
    }, [CustomerDetails]);

// This will handle a input changes in all input fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    if (name === 'Address_GstNumber') {
        setGSTNumber(value);
    }
    if (name === 'Tax_PanNo') {
        setPanCardNumber(value);
    }
        setCustomerDetails(prevDetails => ({
            ...prevDetails,
            [name]: value
        }));
        /******* This will set a errors *********/
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: value ? '' : `${name} is required`
        }));
    };

// Use debounce to prevent too many updates to the Redux store
    const debouncedUpdate = useCallback(
        _.debounce((updatedDetails) => {
            dispatch(UpdateCustomerDataAction({ CustomerDetails: updatedDetails }));
        }, 300),
        [dispatch]
    );
// This will update a values in CustomerDet 
    useEffect(() => { 
        debouncedUpdate(CustomerDet);
    }, [CustomerDet, debouncedUpdate]);

// This will helps to disable the next button without getting all values   
    // useEffect(() => {
    //     const isValid = CustomerDet.Tax_PanNo 
    //     onValidationChange(isValid);
    // }, [CustomerDet, onValidationChange]);
    return (
        <div>
            <div className='StepperGradient'></div>
            <div className='FormDiv'>
            <div className='RowStepper rowstepper2 flex-column align-items-center'>
            <div className='errorTextField'>
             <TextField 
                id="GSTNumber" 
                label="GST Number" 
                variant="outlined" 
                name="Address_GstNumber"
                className='SecondRowStepper'
                value={CustomerDet.Address_GstNumber ? CustomerDet.Address_GstNumber || GSTNumber : GSTNumber}
                onChange={handleInputChange}
            />
                {errors.GSTNumber && (
                    <Typography color="error" variant="caption">{errors.GSTNumber}</Typography>
                )}
            </div>
            <div className='errorTextField'>
            <TextField 
                id="PanCardNumber" 
                label="Pan Card Number" 
                variant="outlined" 
                name="Tax_PanNo"
                className='SecondRowStepper'
                value={CustomerDet.Tax_PanNo ? CustomerDet.Tax_PanNo || PanCardNumber : PanCardNumber}
                onChange={handleInputChange}
            />
            </div>
            </div>
            </div>
        </div>
    )
}

export const BankingDetails = ({onValidationChange}) => {
    const dispatch = useDispatch();
    const customerData = useSelector((state) => state.item.customerData);
    const { CustomerDetails } = customerData;
    const [CustomerDet, setCustomerDetails] = useState({
        Bank_BeneficiaryName: CustomerDetails.customerName ,
        Bank_BeneficiaryAccountNumber: '',
        Bank_Name: '',
        Bank_Branch:'',
        Bank_IFSCCode:'',
        PaymentTerms:'',
        CreditLimit:'',
        bankName:'',
        PaymentName:'',
    });
    const userData = useSelector(selectUser);
    const databaseName = userData?.DatabaseName;
    const userId = userData?.UserId;
    const jwtToken = userData?.JwtToken;
    const navigate = useNavigate();
    const [BankList, setBankList] = useState('');
    const [paymentList, setPaymentList] = useState('');
    // const [BeneficiaryName, setBeneficiaryName]= useState('');
    const [BeneficiaryAccName, setBeneficiaryAccName]= useState('');
    const [BankName, setBankName]= useState('');
    const [BankBranchAddress, setBankBranchAddress]= useState('');
    const [IFCSCode, setIFCSCode]= useState('');
    const [PaymentTerms, setPaymentTerms]= useState('');
    const [CreditLimit, setCreditLimit]= useState('');
    const [bankShow, setBankShow] = useState(false);
    const [PaymentShow, setPaymentShow] = useState(false);
    useEffect(() => {
        const fetchAccountData = async () => {
            try {
                const accountData = await GetData(`${AccountData}${userId}&dbName=${databaseName}`, {
                    headers: {
                        wg_token: jwtToken,
                    },
                }, dispatch, navigate);
                const BankNames = accountData.item5
                const Payments = accountData.item4;

                setBankList(BankNames);
                setPaymentList(Payments);
            } catch (error) {
                console.error("Error fetching group list:", error);
            }
        };
        fetchAccountData();
    }, [databaseName, jwtToken, dispatch]);
    useEffect(() => {
        if (CustomerDetails && (
            CustomerDetails.Bank_Name !== CustomerDet.Bank_Name || 
            CustomerDetails.Bank_BeneficiaryAccountNumber !== CustomerDet.Bank_BeneficiaryAccountNumber ||
            CustomerDetails.Bank_BeneficiaryName !== CustomerDet.Bank_BeneficiaryName ||
            CustomerDetails.Bank_Branch !== CustomerDet.Bank_Branch ||
            CustomerDetails.Bank_IFSCCode !== CustomerDet.Bank_IFSCCode ||
            CustomerDetails.PaymentTerms !== CustomerDet.PaymentTerms ||
            CustomerDetails.CreditLimit !== CustomerDet.CreditLimit 
        )) {
            setCustomerDetails({
                Bank_Name: CustomerDetails.Bank_Name || '',
                Bank_BeneficiaryAccountNumber: CustomerDetails.Bank_BeneficiaryAccountNumber || '',
                Bank_BeneficiaryName: CustomerDetails.customerName || '',
                Bank_Branch: CustomerDetails.Bank_Branch || '',
                Bank_IFSCCode: CustomerDetails.Bank_IFSCCode || '',
                PaymentTerms: CustomerDetails.PaymentTerms || '',
                CreditLimit: CustomerDetails.CreditLimit || '',
            });
        }
    }, [CustomerDetails]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'Bank_BeneficiaryAccountNumber') {
            setBeneficiaryAccName(value);
        }
        if (name === 'Bank_Name') {
            setBankName(value);
        }
        if (name === 'Bank_Branch') {
            setBankBranchAddress(value);
        }
        if (name === 'Bank_IFSCCode') {
            setIFCSCode(value);
        }
        if (name === 'PaymentTerms') {
            setPaymentTerms(value);
        } 
        if (name === 'CreditLimit') {
            setCreditLimit(value);
        } 
        setCustomerDetails(prevDetails => ({
            ...prevDetails,
            [name]: value
        }));
    };

    const debouncedUpdate = useCallback(
        _.debounce((updatedDetails) => {
            dispatch(UpdateCustomerDataAction({ CustomerDetails: updatedDetails }));
        }, 300),
        [dispatch]
    );
    const handleBankSelect = (name, code) => {
        setCustomerDetails((prevState) => ({
            ...prevState,
            Bank_Name: code,
            bankName:name
        }));
        // setErrors(false);
        setBankShow(false); 
    }
    const handlePaymentSelect = (name, code) => {
        setCustomerDetails((prevState) => ({
            ...prevState,
            PaymentTerms: code,
            PaymentName:name
        }));
        // setErrors(false);
        setPaymentShow(false); 
    }
    const handleBankShow = () => {
        setBankShow(true);
    }
    const handlePaymentShow = () => {
        setPaymentShow(true);
    }
    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, () => setBankShow(false));
    useOutsideAlerter(wrapperRef, () => setPaymentShow(false));
    useEffect(() => { 
        debouncedUpdate(CustomerDet);
    }, [CustomerDet, debouncedUpdate]);
    return (
        <div>
            <div className='StepperGradient'></div>
            <div className='FormDiv'>
            <div className='RowStepperTwo align-items-center'>
            <div className='partionDiv'>
            <div className='errorTextFieldTwo'>
             <TextField 
                id="BeneficiaryName"
                name="Bank_BeneficiaryName"
                label="Beneficiary Name"
                variant="outlined"
                disabled
                className='SecondRowStepper'
                value={CustomerDet.Bank_BeneficiaryName}
                onChange={handleInputChange}
              />
              </div>
              <div className='errorTextFieldTwo'>
             <TextField 
                id="BeneficiaryAccName"
                name="Bank_BeneficiaryAccountNumber"
                label="Beneficiary Account Name"
                variant="outlined"
                className='SecondRowStepper'
                value={CustomerDet.Bank_BeneficiaryAccountNumber ? CustomerDet.Bank_BeneficiaryAccountNumber || BeneficiaryAccName : BeneficiaryAccName}
                onChange={handleInputChange}
            />
            </div>
            <div className='errorTextFieldTwo'>
             <TextField 
                id="BankName" 
                label="Bank Name"
                name="Bank_Name" 
                variant="outlined" 
                className='SecondRowStepper'
                value={CustomerDet.bankName ? CustomerDet.bankName || BankName : BankName}
                onChange={handleInputChange}
                onClick={handleBankShow}
            />
            {bankShow && BankList && (
                    <ul className="bankContiner"  ref={wrapperRef}>
                        {BankList.map((Bank, index) => (
                            <li
                                key={index}
                                onClick={() => handleBankSelect(Bank.bankName , Bank.bankCode)}
                            >
                                {Bank.bankName}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className='errorTextFieldTwo'>
             <TextField
                id="BankBranchAddress"   
                label="Bank Branch Address" 
                variant="outlined"
                name="Bank_Branch"
                className='SecondRowStepper'
                value={CustomerDet.Bank_Branch ? CustomerDet.Bank_Branch || BankBranchAddress : BankBranchAddress}
                onChange={handleInputChange}
            />
            </div>
            </div>
            <div className='partionDiv'>
            <div className='errorTextFieldTwo'>
             <TextField 
                id="IFCSCode" 
                label="IFCS Code" 
                variant="outlined" 
                name="Bank_IFSCCode"
                className='SecondRowStepper'
                value={CustomerDet.Bank_IFSCCode ? CustomerDet.Bank_IFSCCode || IFCSCode : IFCSCode}
                onChange={handleInputChange}
            />
            </div>
            <div className='errorTextFieldTwo'>
            <TextField 
                id="PaymentTerms" 
                label="Payment Terms" 
                variant="outlined" 
                name="PaymentTerms"
                className='SecondRowStepper'
                value={CustomerDet.PaymentName}
                onChange={handleInputChange}
                onClick={handlePaymentShow}
                autoComplete='off'
            />
            {PaymentShow && paymentList && (
                    <ul className="PaymentContainer"  ref={wrapperRef}>
                        {paymentList.map((payment, index) => (
                            <li
                                key={index}
                                onClick={() => handlePaymentSelect(payment.pymntGroup, payment.groupNum)}
                            >
                                {payment.pymntGroup}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className='errorTextFieldTwo'>
            
            <TextField 
                id="CreditLimit" 
                label="Credit Limit" 
                variant="outlined" 
                name="CreditLimit"
                className='SecondRowStepper'
                value={CustomerDet.CreditLimit ? CustomerDet.CreditLimit || CreditLimit : CreditLimit}
                onChange={handleInputChange}
            />
            </div>
            </div>
            </div>
            <ToastContainer/>
            </div>
        </div>
    )
}
